module.exports = __webpack_public_path__ + "static/media/ilp_partners.3ceadd44.png";